/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowsH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m22.011 12.06-5.707 5.707-1.414-1.414L18.244 13H5.767l3.354 3.354-1.414 1.414L2 12.06l1-1V11h.061l4.646-4.647 1.414 1.414L5.889 11h12.233L14.89 7.767l1.414-1.414L20.95 11H21v.05z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrowsH as ArrowsH };
